/**
 * Returns an Array of objects into Array of IAutocompleteField
 *
 * @param objectsToParse - Object to parse
 *
 * @param labelKey - Key of object's label
 *
 * @param valueKey - Key of object's id
 *
 * @returns {string} - Array of IAutocompleteFields
 */
export const parseAutocomplete = <T>(
  objectsToParse: Array<T>,
  labelKey: keyof T,
  valueKey: keyof T,
): Array<{ value: string; label: string }> => {
  if (objectsToParse === undefined || objectsToParse === null) {
    return [];
  } else {
    return objectsToParse.map((object) => {
      if (typeof object === 'string') {
        return {
          label: object,
          value: object,
        };
      }
      return {
        label: ((object[labelKey] as unknown) as string).toString(),
        value: ((object[valueKey] as unknown) as string).toString(),
      };
    });
  }
};
